/**
 * Guest-artists is only surfaced for these markets in the city selector.
 * Names must match `targetCity` / worldcities.csv (`city` column).
 */
export const GUEST_ARTISTS_LIVE_CITY_NAMES = [
  'Helsinki',
  'Tampere',
  'Amsterdam',
  'Leipzig',
] as const

export type GuestArtistsLiveCityName = (typeof GUEST_ARTISTS_LIVE_CITY_NAMES)[number]
